/** Runs, read off the mounts a space has held. SES-008 owes the derived interval; this is it. */

import type { MountRecord } from "@nebulize/sdk";

import { useMounts } from "../../spaces/lib/queries";

export interface RunListRow {
  id: string;
  started: string;
  ended: string;
  activity: string;
  version: string;
  ended_by: string;
}

function stamp(at: string | null | undefined): string {
  if (at == null || at === "") return "";
  const when = new Date(at);
  return Number.isNaN(when.getTime()) ? "" : when.toISOString().slice(0, 16).replace("T", " ");
}

function runRowOf(mount: MountRecord): RunListRow {
  return {
    id: mount.mount_id,
    started: stamp(mount.started_at),
    ended: stamp(mount.ended_at),
    activity: mount.activity_id,
    version: mount.activity_version,
    ended_by: mount.end_reason ?? "",
  };
}

/** Newest first, so the run somebody is asking about is the first row. */
export function useSpaceRunRows(spaceId: string): RunListRow[] {
  const mounts = useMounts(spaceId, "all");
  return [...(mounts.data ?? [])]
    .sort((a, b) => (a.started_at < b.started_at ? 1 : -1))
    .map(runRowOf);
}
